import { schema } from 'normalizr';

export const facilitySchema = new schema.Entity(
  'facilities',
  {},
  {
    idAttribute: 'facilityId',
  }
);
